import { config } from "../config";
const formatHelper = {};

formatHelper.currency = (
  value = 0,
  options = { config: {} },
  locale = "en-IN"
) => {
  // Ensure that config is properly initialized
  const currencyConfig = {
    currency: "INR",
    style: "currency",
    useGrouping: true,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    ...options.config, // Spread the config properties into the currencyConfig
  };

  // Add specific checks to ensure the properties exist in options.config
  if (options.config && options.config.minimumFractionDigits !== undefined) {
    currencyConfig.minimumFractionDigits = options.config.minimumFractionDigits;
  }

  if (options.config && options.config.maximumFractionDigits !== undefined) {
    currencyConfig.maximumFractionDigits = options.config.maximumFractionDigits;
  }

  // Special case for zero value
  if (value === 0) {
    currencyConfig.maximumFractionDigits = 0;
    currencyConfig.minimumFractionDigits = 0;
  }

  // Format the value with the provided configuration
  let fixedValue = Number(Number(value).toFixed(currencyConfig.maximumFractionDigits));
  return fixedValue.toLocaleString(locale, currencyConfig);
};


formatHelper.getImageURI = (slug = null) => {
  if (!slug) {
    return;
  }
  let slash = "";
  if (slug.slice(0, 1) !== "/") {
    slash = "/";
  }
  return `${config.apiUrl}${slash}${slug}`;
};

formatHelper.getLegacyImageURI = (slug = null) => {
  if (!slug) {
    return;
  }
  let slash = "";
  if (slug.slice(0, 1) !== "/") {
    slash = "/";
  }
  return `${config.legacyApiUrl}${slash}${slug}`;
};

formatHelper.parseDecimal = (value = null) => {
  if (!value) {
    return;
  }
  return Number(Number(value).toFixed(2));
};

formatHelper.sentenceCase = (str) =>
  str
    .split(" ")
    .map((s) => `${s.charAt(0).toUpperCase()}${s.slice(1).toLowerCase()}`)
    .join(" ");

formatHelper.withZero = (n = 0) => {
  return `0${n}`.substr(-2);
};

formatHelper.getQtyInSlash = (qPending, qFrom, showSameQty = false) => {
  let qtyString = "";
  let q1 = qFrom || qFrom === 0 ? qFrom : "";
  let q2 = qPending || qPending === 0 ? qPending : "";

  if (q1 <= q2 && showSameQty) {
    qtyString = q1;
  } else {
    qtyString = `${q2} / ${q1}`;
  }
  return qtyString;
};

formatHelper.checkVowel = (word) => {
  return ["a", "e", "i", "o", "u", "A", "E", "I", "O", "U"].includes(
    word?.charAt(0)
  );
};

formatHelper.nth = function (d) {
  if (d > 3 && d < 21) return "th";
  switch (d % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

formatHelper.zeroPrefix = (d) => (d < 10 ? `0${d}` : d);

formatHelper.getPaymentFrequencyLabel = (frequencyCode) => {
  switch (frequencyCode) {
    case "MONTHLY":
      return "Monthly";
    case "YEARLY":
      return "Yearly";
    case "HALF_YEARLY":
      return "Half Yearly";
    case "QUARTERLY":
      return "Quarterly";
    default:
      return "Half Yearly";
  }
};

export { formatHelper };
